export const local = {
    production: true,
    baseUrl: 'https://api.backdropprojections.com/',
    imageUrl: 'https://api.backdropprojections.com',
    recaptcha: '6Lfv1dsqAAAAAFpe1Z8Ukbz1pAdjMZBc5wM1lwa4',
    clientKey: '4r7PbmmW4r934A3C8MM6V553BpfznGtcy8pgU4L3XppQ3FAVUTMy8VeJ33efGqce',
    apiLoginID: '7vMmxCNj55Y'
};
